"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fondi": {
    "4a64762b": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "skipSearch": false
    }],
    "curtignano": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7e9c6301": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "skipSearch": false
    }],
    "fasana": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d4ffb919": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "skipSearch": false
    }],
    "gegni": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4e294b3": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "skipSearch": false
    }],
    "passignano": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fc5bbfc6": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "skipSearch": false
    }],
    "rene": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "192867a7": [{
      "hkey": "004c9bbe",
      "slug": "salto-di-fondi-selvavetere-sant-antonio-capratica",
      "name": "Salto di Fondi-Selvavetere-Sant'Antonio-Capratica",
      "primary": true,
      "skipSearch": false
    }],
    "salto-di-fondi": [{
      "hkey": "004c9bbe",
      "slug": "salto-di-fondi-selvavetere-sant-antonio-capratica",
      "name": "Salto di Fondi-Selvavetere-Sant'Antonio-Capratica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f8b53b39": [{
      "hkey": "ba836b00",
      "slug": "querce",
      "name": "Querce",
      "primary": true,
      "skipSearch": false
    }],
    "san-magno-querce": [{
      "hkey": "ba836b00",
      "slug": "querce",
      "name": "Querce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a18d802a": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "skipSearch": false
    }],
    "san-raffaele": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e5e96b5a": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf99020f": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "skipSearch": false
    }],
    "sant-oliva-torricella": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a6bed73d": [{
      "hkey": "004c9bbe",
      "slug": "salto-di-fondi-selvavetere-sant-antonio-capratica",
      "name": "Salto di Fondi-Selvavetere-Sant'Antonio-Capratica",
      "primary": true,
      "skipSearch": false
    }],
    "selva-vetere": [{
      "hkey": "004c9bbe",
      "slug": "salto-di-fondi-selvavetere-sant-antonio-capratica",
      "name": "Salto di Fondi-Selvavetere-Sant'Antonio-Capratica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fondi"
    }],
    "7b88f408": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "skipSearch": false
    }],
    "vardito": [{
      "hkey": "0f678391",
      "slug": "fondi",
      "name": "Fondi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;